import { toastr } from 'react-redux-toastr'
import branditRails from '../../../../api/brandit_rails'
import {
  setCarrierServicesAction,
  setCarrierServicesStatusAction,
  setCarrierServicesErrorsAction,
  clearCarrierServicesErrorsAction,
  clearCarrierServicesAction
} from './carrierServices.actions'

export const fetchCarrierServices =
  (carrier = null, { international, groupByIntegration = false } = {}) =>
  async dispatch => {
    try {
      dispatch(setCarrierServicesStatusAction('loading'))
      dispatch(clearCarrierServicesErrorsAction())

      const params = {
        ...(carrier?.id && { carrier_integration_id: carrier.id }),
        ...(international !== undefined && { international }),
        ...(groupByIntegration && { group_by_integration: true })
      }

      const response = await branditRails.get('/carrier_services', { params })

      dispatch(setCarrierServicesAction(response.data))
      dispatch(setCarrierServicesStatusAction('succeeded'))

      return response.data
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message
      dispatch(setCarrierServicesErrorsAction({ message: errorMessage }))
      dispatch(setCarrierServicesStatusAction('failed'))
      toastr.error('Error', errorMessage)
      throw err
    }
  }

export const clearCarrierServices = () => async dispatch => {
  dispatch(clearCarrierServicesAction())
}
